import { Box, Stack } from "@mui/material";
import {
  RAILCAR_CONNECTOR_LENGTH,
  RAILCAR_CONNECTOR_THICKNESS,
  TRACK_END_BAR_GAP,
  TRACK_END_BAR_LENGTH,
  TRACK_END_BAR_THICKNESS,
} from "./scrapEyeLayoutCommon";

export const RailcarConnectorHorizontal = () => (
  <Box
    sx={{
      width: RAILCAR_CONNECTOR_LENGTH,
      height: RAILCAR_CONNECTOR_THICKNESS,
      bgcolor: "grey.600",
      borderRadius: "2px",
    }}
  />
);

export const TrackEndConnectorHorizontal = () => (
  <Stack
    direction="row"
    spacing={`${TRACK_END_BAR_GAP.toString()}px`}
    alignItems="center"
  >
    <Box
      sx={{
        width: TRACK_END_BAR_LENGTH,
        height: TRACK_END_BAR_THICKNESS,
        bgcolor: "grey.500",
      }}
    />
    <Box
      sx={{
        width: TRACK_END_BAR_LENGTH,
        height: TRACK_END_BAR_THICKNESS,
        bgcolor: "grey.500",
      }}
    />
  </Stack>
);

export const RailcarConnectorVertical = () => (
  <Box
    sx={{
      width: RAILCAR_CONNECTOR_THICKNESS,
      height: RAILCAR_CONNECTOR_LENGTH,
      bgcolor: "grey.600",
      borderRadius: "2px",
    }}
  />
);

export const TrackEndConnectorVertical = () => (
  <Stack
    direction="column"
    spacing={`${TRACK_END_BAR_GAP.toString()}px`}
    alignItems="center"
  >
    <Box
      sx={{
        width: TRACK_END_BAR_THICKNESS,
        height: TRACK_END_BAR_LENGTH,
        bgcolor: "grey.500",
      }}
    />
    <Box
      sx={{
        width: TRACK_END_BAR_THICKNESS,
        height: TRACK_END_BAR_LENGTH,
        bgcolor: "grey.500",
      }}
    />
  </Stack>
);
